module.exports = __webpack_public_path__ + "mobile/img/img_page_bg2.f7bdd076.png";